import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { X } from "lucide-react";
import { BASE_URL } from "../../config/api";
import axios from "axios";

export default function CreatePackage({
  mode = "create",
  packageId,
  packageData,
  onClose,
  onSubmit,
}) {
  const [form, setForm] = useState({
    badge_id: "",
    package_name: "",
    validity_days: "",
    amount: "",
  });

  const [badges, setBadges] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // Prefill form for update mode
  useEffect(() => {
    if (mode === "edit" && packageData) {
      setForm({
        badge_id: packageData.badge_id || "",
        package_name: packageData.package_name || "",
        validity_days: packageData.validity_days || "",
        amount: packageData.amount || "",
      });
    }
  }, [packageData, mode]);

  // Fetch badges
  const fetchBadges = async () => {
  try {

    const response = await axios.get(
      `${BASE_URL}badges`
    );

    const data = response.data;

    setBadges(data || []);

  } catch (err) {

    toast.error(
      err?.response?.data?.message ||
      "Failed to load badges"
    );

  }
};

  useEffect(() => {
    fetchBadges();
  }, []);

  // Validate form
  const validate = () => {
    const newErrors = {};

    if (!form.badge_id) newErrors.badge_id = "Select a badge";
    if (!form.package_name.trim()) newErrors.package_name = "Package name is required";
    if (!form.validity_days || Number(form.validity_days) <= 0)
      newErrors.validity_days = "Enter valid number of days";
    if (!form.amount || Number(form.amount) <= 0)
      newErrors.amount = "Enter valid package amount";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // Input handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    const url =
      mode === "edit"
        ? `${BASE_URL}packages/${packageId}`
        : `${BASE_URL}packages`;

    try {

      const payload = {
        badge_id: Number(form.badge_id),

        package_name:
          form.package_name,

        validity_days: Number(
          form.validity_days
        ),

        amount: Number(form.amount),
      };

      // ✅ CREATE OR UPDATE
      const response =
        mode === "edit"
          ? await axios.put(
              url,
              payload,
              {
                headers: {
                  "Content-Type":
                    "application/json",
                },
              }
            )
          : await axios.post(
              url,
              payload,
              {
                headers: {
                  "Content-Type":
                    "application/json",
                },
              }
            );

      const data = response.data;

      toast.success(
        mode === "edit"
          ? "Package updated successfully"
          : "Package created successfully"
      );

      onSubmit?.(data);

      // 👉 Reset form after create
      if (mode === "create") {
        setForm({
          badge_id: "",
          package_name: "",
          validity_days: "",
          amount: "",
        });
      }

      // 👉 Close modal after edit
      if (
        mode === "edit" &&
        typeof onClose === "function"
      ) {
        onClose();
      }

    } catch (err) {

      toast.error(
        err?.response?.data?.message ||
        "Failed to save package"
      );

    } finally {

      setLoading(false);

    }
  };


  return (
    <div className="bg-white rounded-2xl border border-blue-50 shadow-sm p-4 w-full md:w-[400px] relative">
      {/* Close Button */}
      <button
        onClick={() => typeof onClose === "function" && onClose()}
        className="absolute top-3 right-3 text-slate-500 hover:text-slate-700"
      >
        <X size={20} />
      </button>

      <h2 className="font-semibold text-slate-900 text-sm md:text-base mb-3">
        {mode === "edit" ? "Update Package" : "Create Package"}
      </h2>

      <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4 text-xs md:text-sm">
        {/* Badge Select */}
        <div className="flex flex-col gap-1">
          <label className="text-slate-600">Select Badge</label>

          <select
            name="badge_id"
            value={form.badge_id}
            onChange={handleChange}
            className="border border-slate-200 rounded-lg px-2 py-2 bg-white"
          >
            <option value="">-- Select Badge --</option>
            {badges.length > 0 ? (
              badges.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name} ({b.benefits}%)
                </option>
              ))
            ) : (
              <option disabled>No badges found</option>
            )}
          </select>

          {errors.badge_id && <span className="text-red-500 text-xs">{errors.badge_id}</span>}
        </div>

        {/* Input Fields */}
        {[ 
          { key: "package_name", label: "Package Name", type: "text" },
          { key: "validity_days", label: "Validity (Days)", type: "number" },
          { key: "amount", label: "Amount (₹)", type: "number" },
        ].map((field) => (
          <div key={field.key} className="flex flex-col gap-1">
            <label className="text-slate-600">{field.label}</label>
            <input
              name={field.key}
              type={field.type}
              value={form[field.key]}
              onChange={handleChange}
              className="border border-slate-200 rounded-lg px-2 py-2"
              placeholder={field.label}
            />
            {errors[field.key] && (
              <span className="text-red-500 text-xs">{errors[field.key]}</span>
            )}
          </div>
        ))}

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading}
          className="bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition text-sm"
        >
          {loading ? "Saving..." : mode === "edit" ? "Update Package" : "Create Package"}
        </button>
      </form>
    </div>
  );
}










// import React, { useState } from "react";
// import { STATUSES } from "../../Component/EmployeeComponents/STATUSES";

// export default function CreateLeadForm({ onCreate }) {
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     state: "",
//     district: "",
//     pincode: "",
//     email: "",
//     password: "",
//     address_full: "",
//     lead_amount: ,
//     status: "New",
//   });

//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   // ---------------- VALIDATION ------------------
//   const validate = () => {
//     let newErrors = {};

//     if (!form.name.trim()) newErrors.name = "Name is required";
//     else if (form.name.trim().length < 3)
//       newErrors.name = "Name must be at least 3 characters";

//     if (!form.phone.trim()) newErrors.phone = "Phone is required";
//     else if (!/^[0-9]{10}$/.test(form.phone))
//       newErrors.phone = "Phone must be 10 digits";

//     if (!form.state.trim()) newErrors.state = "State is required";

//     if (!form.district.trim()) newErrors.district = "District is required";

//     if (!/^[0-9]{6}$/.test(form.pincode))
//       newErrors.pincode = "Pincode must be 6 digits";

//     if (form.email && !/^\S+@\S+\.\S+$/.test(form.email))
//       newErrors.email = "Invalid email format";

//     if (!form.password.trim()) newErrors.password = "Password is required";
//     else if (form.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";

//     if (!form.address_full.trim())
//       newErrors.address_full = "Address cannot be empty";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // ---------------- SUBMIT ------------------
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validate()) return; // ❌ Stop submit if validation fails

//     setLoading(true);

//     try {
//       const response = await fetch(
//         "${BASE_URL}/warranty/wlead/store",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         }
//       );

//       const data = await response.json();

//       if (!response.ok) {
//         alert(data?.message || "Failed to create lead");
//         return;
//       }

//       onCreate && onCreate(data);

//       alert("Lead created successfully!");

//       setForm({
//         name: "",
//         phone: "",
//         state: "",
//         district: "",
//         pincode: "",
//         email: "",
//         password: "",
//         address_full: "",
//         status: "New",
//       });
//       setErrors({});
//     } catch (error) {
//       alert("Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---------------- UI ------------------
//   return (
//     <div className="bg-white rounded-2xl border border-blue-50 shadow-sm p-4">
//       <h2 className="font-semibold text-slate-900 text-sm md:text-base mb-3">
//         Create Lead
//       </h2>

//       <form
//         onSubmit={handleSubmit}
//         className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs md:text-sm"
//       >
//         {/* Name */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Name</label>
//           <input
//             name="name"
//             value={form.name}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Full Name"
//           />
//           {errors.name && (
//             <span className="text-red-500 text-xs">{errors.name}</span>
//           )}
//         </div>

//         {/* Phone */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Phone</label>
//           <input
//             name="phone"
//             value={form.phone}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Phone Number"
//           />
//           {errors.phone && (
//             <span className="text-red-500 text-xs">{errors.phone}</span>
//           )}
//         </div>

//         {/* State */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">State</label>
//           <input
//             name="state"
//             value={form.state}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="State Name"
//           />
//           {errors.state && (
//             <span className="text-red-500 text-xs">{errors.state}</span>
//           )}
//         </div>

//         {/* District */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">District</label>
//           <input
//             name="district"
//             value={form.district}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="District Name"
//           />
//           {errors.district && (
//             <span className="text-red-500 text-xs">{errors.district}</span>
//           )}
//         </div>

//         {/* Pincode */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Pincode</label>
//           <input
//             name="pincode"
//             type="number"
//             value={form.pincode}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Pincode"
//           />
//           {errors.pincode && (
//             <span className="text-red-500 text-xs">{errors.pincode}</span>
//           )}
//         </div>

//         {/* Email */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Email</label>
//           <input
//             name="email"
//             type="email"
//             value={form.email}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Email Address"
//           />
//           {errors.email && (
//             <span className="text-red-500 text-xs">{errors.email}</span>
//           )}
//         </div>

//         {/* Password */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Password</label>
//           <input
//             name="password"
//             type="password"
//             value={form.password}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5"
//             placeholder="Password"
//           />
//           {errors.password && (
//             <span className="text-red-500 text-xs">{errors.password}</span>
//           )}
//         </div>

//         {/* Status */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600">Status</label>
//           <select
//             name="status"
//             value={form.status}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5 bg-white"
//           >
//             {STATUSES.map((s) => (
//               <option key={s} value={s}>
//                 {s}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Address Full */}
//         <div className="flex flex-col gap-1 md:col-span-2">
//           <label className="text-slate-600">Full Address</label>
//           <textarea
//             name="address_full"
//             value={form.address_full}
//             onChange={handleChange}
//             className="border border-slate-200 rounded-lg px-2 py-1.5 h-20"
//             placeholder="Complete Address"
//           ></textarea>
//           {errors.address_full && (
//             <span className="text-red-500 text-xs">
//               {errors.address_full}
//             </span>
//           )}
//         </div>

//         {/* Submit */}
//         <button
//           type="submit"
//           disabled={loading}
//           className="md:col-span-2 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition text-sm"
//         >
//           {loading ? "Saving..." : "Save Lead"}
//         </button>
//       </form>
//     </div>
//   );
// }




// import react, { useState } from "react";
// import { STATUSES } from "../../Component/EmployeeComponents/STATUSES";

// export default function CreateLeadForm({ onCreate }) {
//   const [name, setName] = useState("");
//   const [owner, setOwner] = useState("");
//   const [status, setStatus] = useState("New");
//   const [value, setValue] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const numericValue = parseFloat(value) || 0;

//     if (!name.trim() || !owner.trim()) return;

//     // 🚨 Minimum value validation (₹2000)
//     if (numericValue < 2000) {
//       alert("Minimum lead value should be ₹2000");
//       return;
//     }

//     const today = new Date();
//     const createdAt = today.toISOString().slice(0, 10);

//     onCreate({
//       id: Date.now(),
//       name: name.trim(),
//       owner: owner.trim(),
//       status,
//       value: numericValue,
//       createdAt,
//     });

//     setName("");
//     setOwner("");
//     setStatus("New");
//     setValue("");
//   };

//   return (
//     <div className="bg-white rounded-2xl border border-blue-50 shadow-sm p-4">
//       <h2 className="font-semibold text-slate-900 text-sm md:text-base mb-3">
//         Create Lead
//       </h2>

//       <form
//         onSubmit={handleSubmit}
//         className="flex flex-col gap-3 text-xs md:text-sm"
//       >
//         {/* Lead Name */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Lead Name</label>
//           <input
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             placeholder="e.g. New CRM rollout"
//           />
//         </div>

//         {/* Owner */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Owner</label>
//           <input
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm"
//             value={owner}
//             onChange={(e) => setOwner(e.target.value)}
//             placeholder="e.g. Priya Sharma"
//           />
//         </div>

//         {/* Status */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Status</label>
//           <select
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm bg-white"
//             value={status}
//             onChange={(e) => setStatus(e.target.value)}
//           >
//             {STATUSES.map((s) => (
//               <option key={s} value={s}>
//                 {s}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Value (₹) */}
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Value (₹)</label>
//           <input
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm"
//             type="number"
//             min="2000"                    // 🔥 HTML minimum
//             value={value}
//             onChange={(e) => setValue(e.target.value)}
//             placeholder="Minimum value ₹2000"
//           />
//         </div>

//         {/* Save Button */}
//         <button
//           type="submit"
//           className="mt-1 inline-flex items-center justify-center rounded-lg bg-blue-600 text-white text-xs md:text-sm font-medium py-1.5 px-3 hover:bg-blue-700 transition-colors"
//         >
//           Save Lead
//         </button>
//       </form>
//     </div>
//   );
// }


// import react, { useState } from "react";
// import { STATUSES } from "../../Component/EmployeeComponents/STATUSES";
// export default function CreateLeadForm({ onCreate }) {
//   const [name, setName] = useState("");
//   const [owner, setOwner] = useState("");
//   const [status, setStatus] = useState("New");
//   const [value, setValue] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const numericValue = parseFloat(value) || 0;
//     if (!name.trim() || !owner.trim() || numericValue <= 0) return;

//     const today = new Date();
//     const createdAt = today.toISOString().slice(0, 10);

//     onCreate({
//       id: Date.now(),
//       name: name.trim(),
//       owner: owner.trim(),
//       status,
//       value: numericValue,
//       createdAt,
//     });

//     setName("");
//     setOwner("");
//     setStatus("New");
//     setValue("");
//   };

//   return (
//     <div className="bg-white rounded-2xl border border-blue-50 shadow-sm p-4">
//       <h2 className="font-semibold text-slate-900 text-sm md:text-base mb-3">
//         Create Lead
//       </h2>
//       <form
//         onSubmit={handleSubmit}
//         className="flex flex-col gap-3 text-xs md:text-sm"
//       >
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Lead Name</label>
//           <input
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             placeholder="e.g. New CRM rollout"
//           />
//         </div>
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Owner</label>
//           <input
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm"
//             value={owner}
//             onChange={(e) => setOwner(e.target.value)}
//             placeholder="e.g. Priya Sharma"
//           />
//         </div>
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Status</label>
//           <select
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm bg-white"
//             value={status}
//             onChange={(e) => setStatus(e.target.value)}
//           >
//             {STATUSES.map((s) => (
//               <option key={s} value={s}>
//                 {s}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div className="flex flex-col gap-1">
//           <label className="text-slate-600 text-xs">Value (₹)</label>
//           <input
//             className="border border-slate-200 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs md:text-sm"
//             type="number"
//             min="0"
//             value={value}
//             onChange={(e) => setValue(e.target.value)}
//             placeholder="e.g. 50000"
//           />
//         </div>
//         <button
//           type="submit"
//           className="mt-1 inline-flex items-center justify-center rounded-lg bg-blue-600 text-white text-xs md:text-sm font-medium py-1.5 px-3 hover:bg-blue-700 transition-colors"
//         >
//           Save Lead
//         </button>
//       </form>
//     </div>
//   );
// }